import React from 'react';
import { translate } from 'react-i18next';

import ShiftDetailBlock from 'components/ScheduleSidebar/ShiftDetailBlock.js';
import EmployeeActions from 'actions/EmployeeActions.js';

class SidebarShiftOffer extends React.Component {
  constructor(props) {
    super(props);

    this.onShiftById = this.onShiftById.bind(this);
    this.onRemoveShift = this.onRemoveShift.bind(this);
    this.renderUserName = this.renderUserName.bind(this);

    this.state = {
      shiftData: null,
    };
  }

  componentDidMount() {
    if (
      _.isEmpty(this.props.shiftData)
      || (_.isUndefined(this.props.shiftData.shift_details)
        && _.isUndefined(this.props.shiftData.date))
    ) {
      EmployeeActions.getShiftById(this.props.shiftID);
      ShiftStore.on('shift_by_id:load:success', this.onShiftById);
    } else {
      this.setState({
        shiftData: this.props.shiftData,
      });
    }
  }

  componentWillReceiveProps(newProps) {
    if (_.isEqual(newProps.shiftData, this.props.shiftData)) {
      this.setState({
        shiftData: newProps.shiftData,
      });
    }
  }

  onShiftById(collection, response) {
    if (this.props.shiftID == collection.data.id) {
      this.setState({
        shiftData: collection.data,
      });
    }
  }

  onRemoveShift() {
    this.props.onRemoveShiftSelection(this.props.shiftData);
  }

  renderUserName() {
    if (this.props.userName) {
      return(<span>{this.props.userName} <br/> </span>);
    }
  }

  render() {
    let startTime = '';
    let endTime = '';

    if (this.props.active && !Utils.isNotDefined(this.state.shiftData)) {
      startTime = moment(this.state.shiftData.start_time)
        .tz(this.state.shiftData.time_zone)
        .format('h:mm a');
      endTime = moment(this.state.shiftData.end_time)
        .tz(this.state.shiftData.time_zone)
        .format('h:mm a');
      var hideEnd = this.state.shiftData.hide_end_time;

      var breaks = null;
      if (
        !Utils.isNotDefined(this.state.shiftData)
        && !Utils.isNotDefined(this.state.shiftData.breaks)
      ) {
        breaks = Utils.formatUnformattedBreaks(this.state.shiftData.breaks);
      }

      var notes = null;
      if (
        !Utils.isNotDefined(this.state.shiftData)
        && !Utils.isNotDefined(this.state.shiftData.shift_notes)
      ) {
        notes = this.state.shiftData.shift_notes;
      }
    }

    const classes = `calendar-input shift-details ${!this.props.active ? 'hide' : ''}`;
    const shiftLabel = this.props.accepted ? this.props.t('SidebarShiftOffer.accepted_shift') : this.props.t('SidebarShiftOffer.selected_shift');

    let removeShiftButtonClasses = 'calendar-input-button shift-drop-cancel-button';
    if (this.props.accepted || !this.props.exchangeDaySelectMode) {
      removeShiftButtonClasses += ' hide';
    }

    if (this.props.overlappedShift) {
      removeShiftButtonClasses += ' hide';
    }

    let shiftDate = '';
    if (this.state.shiftData) {
      const momentObj = moment(this.state.shiftData.start_time)
        .tz(this.state.shiftData.time_zone);
      shiftDate = Utils.formatLocaleDate(momentObj);
    }

    return (
      <div className={classes}>
        <span className="calendar-input-bullet scheduled">{shiftLabel}</span>
        <div className="shift-detail-content">
          <p className="shift-detail-title">
            {this.renderUserName()}
            {this.state.shiftData ? this.state.shiftData.name : ''}
            <br />
            {shiftDate}
            <br />
            {startTime}
            {' – '}
            {!hideEnd ? endTime : this.props.t('SidebarShiftOffer.tbd')}
          </p>

          {!Utils.isNotDefined(breaks) && (
            <p className="shift-detail-breaks">
              {this.props.t('SidebarShiftOffer.breaks')}:&nbsp;
              {breaks}
            </p>
          )}
          <ShiftDetailBlock
            departmentID={this.state.shiftData ? this.state.shiftData.department_id : ''}
            locationID={this.state.shiftData ? this.state.shiftData.location_id : ''}
            position={this.state.shiftData ? this.state.shiftData.position : ''}
            job_site_name={this.state.shiftData ? this.state.shiftData.job_site_name : ''}
            job_site_address={this.state.shiftData ? this.state.shiftData.job_site_address : ''}
          />
          {!Utils.isNotDefined(notes) && (
            <div className="shift-detail-notes-container">
              <p className="shift-detail-title">{this.props.t('SidebarShiftOffer.notes').toUpperCase()}</p>
              <p className="shift-detail-notes">{notes}</p>
            </div>
          )}
          <button className={removeShiftButtonClasses} onClick={this.onRemoveShift}>
            {this.props.t('SidebarShiftOffer.remove_shift')}
          </button>
        </div>
      </div>
    );
  }
}

export default translate()(SidebarShiftOffer);
